import { Nullable } from 'utils/types';

export enum API_FIELDS {
  APPLICANT_1 = 'applicant1',
  APPLICANT_2 = 'applicant2',

  CASE_ID = 'caseId',
  NUMBER_OF_APPLICANTS = 'numberOfApplicants',
  ACCOUNT_NUMBER = 'accountNumber',
  SORT_CODE = 'sortCode',
  ORIGINATION_ID = 'originatorId',
  TITLE_NUMBER = 'titleNumber',
  FLAT_NUMBER = 'flatNumber',
  BUILDING_NUMBER = 'buildingNumber',
  BUILDING_NAME = 'buildingName',
  STREET = 'street',
  CITY = 'city',
  PROPERTY_POST_CODE = 'postcode',
  PROPERTY_TYPE = 'type',
  TENURE = 'propertyTenure',
  PROPERTY_BUILT_YEAR = 'builtYear',
  ACTUAL_PROPERTY_VALUE = 'actualPropertyValue',
  INSPECTION_DATE = 'inspectedAt',
  PEPPER_PURPOSE_OF_THE_LOAN = 'pepperPurposeOfTheLoan',
  FCA_LOAN_PURPOSE = 'fcaLoanPurpose',
  NET_LOAN = 'netLoan',
  IS_BUY_TO_LET = 'isBuyToLet',
  PEPPER_PRODUCT_NAME = 'pepperProductName',
  PRODUCT_FEE = 'productFee',
  COMPLETION_DATE = 'completionDate',
  FIXED_INTEREST_RATE = 'fixedInterestRate',
  IS_MARGIN_ACTIVE = 'marginActive',
  IS_APP_ACTIVE = 'appActive',
  PRODUCT_FEE_PAYMENT = 'productFeePayment',
  REVERT_MARGIN = 'revertMargin',
  LVR = 'lvr',

  // Applicant 1/2
  BORROWER_PHONE_MOBILE = 'phoneMobile',
  BORROWER_PHONE_HOME = 'phoneHome',
  BORROWER_PHONE_WORK = 'phoneWork',
  BORROWER_EMAIL = 'email',
  BORROWER_ADDITIONAL_EMAIL = 'additionalEmail',
  BORROWER_LAST_NAME = 'lastName',
  BORROWER_FIRST_NAME = 'firstName',
  BORROWER_TITLE = 'title',
  BORROWER_DATE_OF_BIRTH = 'dateOfBirth',
  BORROWER_GENDER = 'gender',
  BORROWER_EMPLOYMENT_STATUS = 'employmentStatus',
  BORROWER_TOTAL_CURRENT_INCOME = 'totalCurrentIncome',
  VARIABLE_TERM_START_DATE = 'variableTermStartDate',
  NUMBER_OF_PAYMENTS = 'numberOfPayments',
}

export type Applicant = {
  [API_FIELDS.BORROWER_LAST_NAME]: Nullable<string>;
  [API_FIELDS.BORROWER_FIRST_NAME]: Nullable<string>;
  [API_FIELDS.BORROWER_TITLE]: Nullable<string>;
  [API_FIELDS.BORROWER_DATE_OF_BIRTH]: Nullable<string>;
  [API_FIELDS.BORROWER_GENDER]: Nullable<string>;
  [API_FIELDS.BORROWER_EMPLOYMENT_STATUS]: Nullable<string>;
  [API_FIELDS.BORROWER_TOTAL_CURRENT_INCOME]: Nullable<number>;
  [API_FIELDS.BORROWER_PHONE_HOME]: Nullable<number>;
  [API_FIELDS.BORROWER_PHONE_MOBILE]: Nullable<number>;
  [API_FIELDS.BORROWER_PHONE_WORK]: Nullable<number>;
  [API_FIELDS.BORROWER_EMAIL]: Nullable<string>;
  [API_FIELDS.BORROWER_ADDITIONAL_EMAIL]: Nullable<string>;
  [API_FIELDS.BORROWER_TOTAL_CURRENT_INCOME]: Nullable<number>;
};

export type PepperReviewSummary = {
  /* General section */
  [API_FIELDS.CASE_ID]: string;
  [API_FIELDS.ORIGINATION_ID]: string;
  [API_FIELDS.NUMBER_OF_APPLICANTS]: number;
  [API_FIELDS.ACCOUNT_NUMBER]: Nullable<number>;
  [API_FIELDS.SORT_CODE]: Nullable<string>;

  /*  Mortgage Property section */
  [API_FIELDS.TITLE_NUMBER]: Nullable<string>;
  [API_FIELDS.FLAT_NUMBER]: Nullable<string>;
  [API_FIELDS.BUILDING_NUMBER]: Nullable<string>;
  [API_FIELDS.BUILDING_NAME]: Nullable<string>;
  [API_FIELDS.STREET]: Nullable<string>;
  [API_FIELDS.CITY]: Nullable<string>;
  [API_FIELDS.PROPERTY_POST_CODE]: Nullable<string>;
  [API_FIELDS.PROPERTY_TYPE]: Nullable<string>;
  [API_FIELDS.TENURE]: Nullable<string>;
  [API_FIELDS.PROPERTY_BUILT_YEAR]: Nullable<number>;
  [API_FIELDS.ACTUAL_PROPERTY_VALUE]: Nullable<number>;
  [API_FIELDS.INSPECTION_DATE]: Nullable<string>;

  /* Loan section */
  [API_FIELDS.PEPPER_PURPOSE_OF_THE_LOAN]: Nullable<string>;
  [API_FIELDS.FCA_LOAN_PURPOSE]: Nullable<string>;
  [API_FIELDS.NET_LOAN]: Nullable<number>;
  [API_FIELDS.IS_BUY_TO_LET]: Nullable<boolean>;
  [API_FIELDS.PEPPER_PRODUCT_NAME]: Nullable<string>;
  [API_FIELDS.IS_MARGIN_ACTIVE]: Nullable<boolean>;
  [API_FIELDS.IS_APP_ACTIVE]: Nullable<boolean>;
  [API_FIELDS.PRODUCT_FEE]: Nullable<number>;
  [API_FIELDS.PRODUCT_FEE_PAYMENT]: Nullable<boolean>;
  [API_FIELDS.COMPLETION_DATE]: Nullable<string>;
  [API_FIELDS.VARIABLE_TERM_START_DATE]: Nullable<string>;
  [API_FIELDS.NUMBER_OF_PAYMENTS]: Nullable<string>;
  [API_FIELDS.FIXED_INTEREST_RATE]: Nullable<number>;
  [API_FIELDS.REVERT_MARGIN]: Nullable<number>;
  [API_FIELDS.LVR]: Nullable<string>;

  /* Borrower(s) */
  [API_FIELDS.APPLICANT_1]: Applicant;
  [API_FIELDS.APPLICANT_2]: Nullable<Applicant>;
};
